import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';
import { zip } from 'rxjs';


@Component({
    selector: 'app-wiz-facturacion',
    templateUrl: './wiz-facturacion.component.html',
    styleUrls: ['./wiz-facturacion.component.scss']
})
export class WizFacturacionComponent {
    @Input() accountForm: FormGroup;
    @Input() rfcAvailable: boolean = false;
    @Input() razonSocialAvailable: boolean = false;

    @Output() rfcAvailableChange = new EventEmitter<boolean>();
    @Output() razonSocialAvailableChange = new EventEmitter<boolean>();

    uuidPattern = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
    catReg: any;
    catGiro: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[];
    
    rfcValidationStarted: boolean = false;
    razonSocialValidationStarted: boolean = false;


    constructor(
        private _formBuilder: FormBuilder,
        private coalService: CoalService,
    ) {

    }

    ngOnInit() {
        this.getCatalogo();
    }

    // Declaración de las variables que contienen los catálogos
    catTipoPersona: any[] = [];
    catGiroMoral: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
    catGiroFisica: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];
    catRegimenMoral: any;
    catRegimenFisico: any;
    catTamanio: { idCatalogo: number; nombre: string; descripcion: any; valor: string; }[] = [];

    // Método que obtiene los catálogos y los almacena en las variables correspondientes
    getCatalogo() {
        zip(
            this.coalService.getService('cat-tipo-personas'),
            this.coalService.getService('cat-giros'),
            this.coalService.getService('cat-regimenes-fiscal'),
            this.coalService.getService('cat-tamanio-empresas')
        ).subscribe((res: any) => {
            this.catTipoPersona = res[0].data;
            this.catGiroMoral = res[1].data.filter(x => x.attributes.aplicaMoral);
            this.catGiroFisica = res[1].data.filter(x => x.attributes.aplicaFisico);
            this.catRegimenMoral = res[2].data.filter(x => x.attributes.aplicaMoral);
            this.catRegimenFisico = res[2].data.filter(x => x.attributes.aplicaFisico);
            this.catTamanio = res[3].data;
        }, (error: any) => {
            console.log(error);
        });
    }

    // Método para establecer los valores de giro y régimen fiscal según el tipo de persona seleccionado
    setDataGiro() {
        const idRegimenFiscal = this.accountForm.controls.idRegimenFiscal.value;
        const idGiro = this.accountForm.controls.idGiro.value;

        const isMoral = this.catTipoPersona.find(x => x.id === this.accountForm.value.idTipoPersona)?.attributes?.nombre?.toUpperCase()?.indexOf("MORAL") > -1;
        
        if (isMoral) {
            this.catReg = this.catRegimenMoral;
            this.catGiro = this.catGiroMoral;
        } else {
            this.catReg = this.catRegimenFisico;
            this.catGiro = this.catGiroFisica;
        }

        // Si los campos ya tienen valor y el tipo de persona no ha cambiado, no se limpian
        if (!idRegimenFiscal || !this.catReg.some(x => x.id === idRegimenFiscal)) {
            this.accountForm.controls.idRegimenFiscal.setValue(null);
        }
        if (!idGiro || !this.catGiro.some((x: any) => x.id === idGiro)) {
            this.accountForm.controls.idGiro.setValue(null);
        }
    }
    // setDataGiro() {
    //     if (this.catTipoPersona.find(x => x.id === this.accountForm.value.idTipoPersona)?.attributes?.nombre?.toUpperCase()?.indexOf("MORAL") > -1) {
    //         this.catReg = this.catRegimenMoral;
    //         this.catGiro = this.catGiroMoral;
    //     } else {
    //         this.catReg = this.catRegimenFisico;
    //         this.catGiro = this.catGiroFisica;
    //     }
    //     this.accountForm.controls.idRegimenFiscal.setValue(null);
    //     this.accountForm.controls.idGiro.setValue(null);
    // }

    onRfcBlur(): void {
        const rfcControl = this.accountForm.get('rfc');
    
        if (rfcControl && rfcControl.valid) {
            const rfcValue = rfcControl.value;
            const currentRfcType = this.accountForm.get('idTipoPersona')?.value;
            const newRfcType = this.determineRfcType(rfcValue);
    
            if (newRfcType !== currentRfcType) {
                // Si el tipo de persona cambia, actualiza y resetea los campos
                this.accountForm.get('idTipoPersona')?.setValue(newRfcType);
                this.setDataGiro();
                this.accountForm.controls.idRegimenFiscal.setValue(null);
                this.accountForm.controls.idGiro.setValue(null);
            } else if (!currentRfcType && newRfcType) {
                // Si no hay un tipo de persona seleccionado y el RFC es válido
                this.accountForm.get('idTipoPersona')?.setValue(newRfcType);
                this.setDataGiro();
            }
    
            this.comprobarRFC(rfcValue).then((result) => {
                this.rfcValidationStarted = true;
                this.rfcAvailable = !result.registrado;
                this.rfcAvailableChange.emit(this.rfcAvailable);
            }).catch((error) => {
                console.error('Error al comprobar el RFC:', error);
            });
        } else {
            console.log('Formato de RFC inválido');
        }
    }

    // onRfcBlur(): void {
    //     const rfcControl = this.accountForm.get('rfc');
    
    //     if (rfcControl && rfcControl.valid) {
    //         // RFC válido, lanzar la petición
    //         const rfcValue = rfcControl.value;
    //         const rfcType = this.determineRfcType(rfcValue);
    //         this.accountForm.get('idTipoPersona')?.setValue(rfcType);
    //         this.setDataGiro();
    //         this.comprobarRFC(rfcValue).then((result) => {
    //             this.rfcValidationStarted = true;
    //             if (result.registrado) {
    //                 // Mostrar un mensaje de error o alertar al usuario que el RFC ya está registrado
    //                 console.log('El RFC ya está registrado:', result.data);
    //                 this.rfcAvailable = false;
    //             } else {
    //                 // El RFC no está registrado, puedes continuar con el proceso normal
    //                 console.log('El RFC no está registrado.');
    //                 this.rfcAvailable = true;
    //             }
    //             this.rfcAvailableChange.emit(this.rfcAvailable);
    //         }).catch((error) => {
    //             console.error('Error al comprobar el RFC:', error);
    //         });
    //     } else {
    //         // RFC no válido, no hacer nada o mostrar un mensaje de error
    //         console.log('Formato de RFC inválido');
    //     }
    // }

    comprobarRFC(rfc: string): Promise<{ registrado: boolean, data?: any }> {
        return new Promise((resolve, reject) => {
            const query = `ope-empresas?filters[rfc][$eq]=${rfc}`;
            this.coalService.getService(query)
                .subscribe({
                    next: (res: any) => {
                        if (res.data && res.data.length > 0) {
                            resolve({ registrado: true, data: res.data });
                        } else {
                            resolve({ registrado: false });
                        }
                    },
                    error: (error: any) => reject(error)
                });
        });
    }   

    onRazonSocialBlur(): void {
        const razonSocialControl = this.accountForm.get('razonSocial');
    
        if (razonSocialControl && razonSocialControl.valid) {
            // Razón social válida, lanzar la petición
            const razonSocialValue = razonSocialControl.value;
            this.comprobarRazonSocial(razonSocialValue).then((result) => {
                this.razonSocialValidationStarted = true;
                if (result.registrado) {
                    // Mostrar un mensaje de error o alertar al usuario que la razón social ya está registrada
                    console.log('La razón social ya está registrada:', result.data);
                    this.razonSocialAvailable = false;
                } else {
                    // La razón social no está registrada, puedes continuar con el proceso normal
                    console.log('La razón social no está registrada.');
                    this.razonSocialAvailable = true;
                }
                this.razonSocialAvailableChange.emit(this.razonSocialAvailable);
            }).catch((error) => {
                console.error('Error al comprobar la razón social:', error);
            });
        } else {
            // Razón social no válida, no hacer nada o mostrar un mensaje de error
            console.log('Formato de razón social inválido');
        }
    }

    comprobarRazonSocial(razonSocial: string): Promise<{ registrado: boolean, data?: any }> {
        return new Promise((resolve, reject) => {
            const query = `ope-empresas?filters[razonSocial][$eq]=${razonSocial}`;
            this.coalService.getService(query)
                .subscribe({
                    next: (res: any) => {
                        if (res.data && res.data.length > 0) {
                            resolve({ registrado: true, data: res.data });
                        } else {
                            resolve({ registrado: false });
                        }
                    },
                    error: (error: any) => reject(error)
                });
        });
    }
    
    determineRfcType(rfc: string){
        if (!rfc || (rfc.length !== 12 && rfc.length !== 13)) {
            return 0;
        }
    
        const moralPattern = /^[A-Z&Ñ]{3}\d{6}[A-Z\d]{3}$/;  // 3 letras, 6 dígitos, 3 alfanuméricos
        const fisicaPattern = /^[A-Z&Ñ]{4}\d{6}[A-Z\d]{3}$/; // 4 letras, 6 dígitos, 3 alfanuméricos
    
        if (moralPattern.test(rfc)) {
            return 2;
        }
    
        if (fisicaPattern.test(rfc)) {
            return 1;
        }
    
        return 0;
    }

    convertToUpper(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        inputElement.value = inputElement.value.toUpperCase();
        this.accountForm.get('rfc')?.setValue(inputElement.value);
    }
    
    
}
